(function () {
  "use strict";

  var CEILING_M = 2.44; // 8ft, the Indian marketing convention
  var SQM_TO_SQFT = 10.764;

  function coverage(cadr) {
    function r(n) {
      return Math.round(n / 10) * 10;
    }
    return {
      ach1: r((cadr / (1 * CEILING_M)) * SQM_TO_SQFT),
      ach3: r((cadr / (3 * CEILING_M)) * SQM_TO_SQFT),
      ach5: r((cadr / (5 * CEILING_M)) * SQM_TO_SQFT)
    };
  }

  var MODELS = {
    vortex: {
      label: "Vortex", price: 13999, cadr: 400, cadrHedge: true, type: "room",
      mech: [
        ["Dust, pollen, grit", "Pre-filter + near medical-grade H13 HEPA"],
        ["Smoke, gases, odours", "Activated carbon + catalytic net"],
        ["Ultrafine particles", "H13 HEPA + ioniser, assisted by Brownian diffusion capture — the same physics all true HEPA filters use for sub-0.3-micron particles, though most Indian brands don't say so"],
        ["Germs in the air", "UV ioniser, certified ozone-free"]
      ]
    },
    bioguard: {
      label: "Bio Guard", price: 39999, cadr: 488, cadrHedge: false, type: "room", hasUVC: true,
      mech: [
        ["Dust, pollen, grit", "Pre-filter + near medical-grade H13 HEPA"],
        ["Smoke, gases, odours", "Heavy honeycomb activated carbon"],
        ["Ultrafine particles", "H13 HEPA + ioniser via Brownian diffusion capture below the standard 0.3-micron test point"],
        ["Germs in the air", "UV-C + silver & copper ion coating, certified ozone-free"],
        ["Germs on the filter itself", "UV-C also sterilises the filter surface, so it doesn't become a breeding ground — most brands only treat the air passing through, not the filter sitting behind it"]
      ]
    },
    atmos: {
      label: "Atmos", price: 49999, cadr: 500, cadrHedge: false, type: "room",
      mech: [
        ["Dust, pollen, grit", "Washable pre-filter + near medical-grade H13 HEPA"],
        ["Smoke, gases, odours", "Cold catalyst + honeycomb activated carbon — breaks down formaldehyde/VOCs at room temperature, no heat needed"],
        ["Ultrafine particles", "H13 HEPA + ioniser via Brownian diffusion capture below 0.3 microns"],
        ["Germs in the air", "UV ioniser, certified ozone-free"],
        ["Dry air (AC-heavy Indian homes)", "Built-in humidifier — the only model in the range with this, relevant for most of India through the AC/winter months"]
      ]
    },
    titan: {
      label: "Titan", price: 49999, cadr: 760, cadrHedge: false, type: "room", hasUVC: true,
      mech: [
        ["Dust, pollen, grit", "Washable pre-filter + near medical-grade H13 HEPA"],
        ["Smoke, gases, odours", "Cold catalyst + honeycomb activated carbon"],
        ["Ultrafine particles", "H13 HEPA + ioniser via Brownian diffusion capture below 0.3 microns"],
        ["Germs in the air", "UV-C + silver & copper ion coating, certified ozone-free"],
        ["Germs on the filter itself", "UV-C sterilises the filter surface directly"]
      ]
    },
    drive: {
      label: "Drive", price: 7999, cadr: 22, type: "car",
      mech: [
        ["Particles in cabin air", "H12 HEPA + activated carbon"],
        ["Odours, smoke, exhaust", "Activated carbon + dual ioniser (16 million ions/cm² combined), certified ozone-free"],
        ["Convenience", "Auto-starts with ignition, resumes last setting, USB-C, CARB-compliant, doubles as a desk unit"]
      ]
    },
    sentry: {
      label: "Sentry", price: 5999, type: "monitor",
      mech: [
        ["What it tracks", "AQI, CO2, CO, PM0.3 / PM1.0 / PM2.5 / PM10, HCHO, TVOC, temperature, humidity — 15-point air intelligence in one unit"],
        ["Where it sits", "Placed in your actual breathing zone (bedside, desk) rather than built into a purifier reading its own outlet air"],
        ["Home automation", "WiFi with if/then automation — can trigger a KyoAir purifier to respond to its real-time readings, not just log data for later"]
      ]
    }
  };

  var ENDPOINTS = {
    chatgpt: "https://chatgpt.com/?q=",
    claude: "https://claude.ai/new?q=",
    perplexity: "https://www.perplexity.ai/search?q="
  };

  var askCompetitor = "Ask me which purifier I want to compare this against, then wait for my answer before starting the comparison. If I'm unsure, suggest a few fair rivals at a similar price and let me pick — not the cheapest one you can find.";

  var rulesLine = "Rules: check current Amazon India prices for both, don't reuse old numbers. Weigh both brands' claims against independent sources, not just their own marketing copy. If the competitor's number isn't real tested CADR (e.g. raw/projected airflow like Dyson uses) — don't convert it into ACH, say so plainly and compare on real metrics instead. Flag anything inflated, unverifiable, or based on training data instead of live browsing.";

  var guaranteeLine = "Guarantee: 15 days, measured — an air quality monitor before/after under normal use (closed doors/windows, right-sized room, fair runtime), full refund if no verified improvement. Not a promise on outdoor AQI or open windows — no appliance controls that. Check if the competitor's guarantee is tied to any real measurement or just a standard return window.";

  function filtrationText(m) {
    return m.mech.map(function (pair) {
      return "- " + pair[0] + ": " + pair[1];
    }).join("\n");
  }

  function priceStr(m) {
    return "₹" + m.price.toLocaleString("en-IN");
  }

  function buildPrompt(m) {
    var uvcLine = m.hasUVC ? " UV-C dosage is tested to a validated germicidal threshold, not just \"UV-C inside\" — docs on file, available on request." : "";

    if (m.type === "room") {
      var cov = coverage(m.cadr);
      var cadrLine = m.cadrHedge
        ? "CADR: up to " + m.cadr + " m³/h (still being lab-certified — treat as a manufacturer figure; every other KyoAir model already has a certificate on file)."
        : "CADR: " + m.cadr + " m³/h, lab-certified, not a self-reported number.";
      var coverageLine = "Coverage: Indian brands advertise at ACH1/8ft (loosest standard) — that's " + cov.ach1 + " sq ft here. Real ACH3 (effective minimum) is " + cov.ach3 + " sq ft, ACH5 (optimum) is " + cov.ach5 + " sq ft. Do the same ACH1/3/5 math for the competitor using their real CADR, not their marketing sq ft figure.";

      return "Genuine buyer question, no fluff: considering the KyoAir " + m.label + " (" + priceStr(m) + ") for my home. Give me an honest, independently-checked opinion — verify my numbers and theirs, don't just agree with me.\n\n" +
        "KyoAir " + m.label + ":\n" +
        "- " + cadrLine + "\n" +
        "- " + coverageLine + "\n" +
        "- Filtration (check each mechanism against the competitor, don't average it into one paragraph):\n" +
        filtrationText(m) + uvcLine + "\n" +
        "- " + guaranteeLine + "\n\n" +
        askCompetitor + "\n\n" +
        rulesLine + "\n\n" +
        "Verdict: where KyoAir wins, where it's weaker, fair price or not. Be blunt, tell me if I should look elsewhere. Under 250 words.";
    }

    if (m.type === "car") {
      var carCadrLine = "CADR: " + m.cadr + " m³/h, lab-certified. A hatchback/sedan cabin is ~2.5–3 m³, so that's a full turnover roughly every 7–10 minutes — check the math, and do the same for the competitor using their real CADR against the same cabin volume.";
      var carGuaranteeLine = guaranteeLine.replace("an air quality monitor before/after under normal use", "an air quality monitor before/after in the cabin");

      return "Genuine buyer question, no fluff: considering the KyoAir " + m.label + " (" + priceStr(m) + ") for my car. Give me an honest, independently-checked opinion.\n\n" +
        "KyoAir " + m.label + ":\n" +
        "- " + carCadrLine + "\n" +
        "- Filtration:\n" +
        filtrationText(m) + "\n" +
        "- " + carGuaranteeLine + "\n\n" +
        askCompetitor + "\n\n" +
        rulesLine + "\n\n" +
        "Verdict: real cabin turnover time (not just marketing CADR), filtration depth, noise, running cost, fair price or not. Under 200 words.";
    }

    // monitor
    return "Genuine buyer question, no fluff: considering the KyoAir " + m.label + " (" + priceStr(m) + ") as a standalone air quality monitor. Give me an honest, independently-checked opinion.\n\n" +
      "KyoAir " + m.label + ":\n" +
      filtrationText(m) + "\n\n" +
      askCompetitor + "\n" +
      "Pricier options exist — check if any gap is real sensor/pollutant-range superiority, or brand premium with weaker home-automation integration. Don't assume price or brand name means better sensors; check the actual sensor tech if published.\n\n" +
      rulesLine + "\n\n" +
      "Verdict: where Sentry is genuinely competitive, where it's behind, fair price or not. Under 180 words.";
  }

  function legacyCopy(text) {
    var ta = document.createElement("textarea");
    ta.value = text;
    ta.setAttribute("readonly", "");
    ta.style.position = "fixed";
    ta.style.top = "-9999px";
    ta.style.left = "-9999px";
    document.body.appendChild(ta);
    ta.select();
    try {
      document.execCommand("copy");
    } catch (e) {}
    document.body.removeChild(ta);
  }

  function copyText(text) {
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(text).catch(function () {
        legacyCopy(text);
      });
    } else {
      legacyCopy(text);
    }
  }

  function trackClick(aiPlatform, productKey) {
    try {
      if (window.dataLayer) {
        window.dataLayer.push({ event: "ai_audit_click", ai_platform: aiPlatform, product_key: productKey });
      }
    } catch (e) {}
    try {
      if (typeof window.gtag === "function") {
        window.gtag("event", "ai_audit_click", { ai_platform: aiPlatform, product_key: productKey });
      }
    } catch (e) {}
    try {
      if (window.analytics && typeof window.analytics.track === "function") {
        window.analytics.track("ai_audit_click", { ai_platform: aiPlatform, product_key: productKey });
      }
    } catch (e) {}
  }

  function initAudit(root) {
    var key = root.getAttribute("data-product-key");
    if (!MODELS[key]) {
      console.warn("[kyoair-ai-audit] unknown product key \"" + key + "\", falling back to vortex");
      key = "vortex";
    }
    var model = MODELS[key];
    var livePrice = parseInt(root.getAttribute("data-product-price"), 10);
    if (livePrice) {
      model = Object.assign({}, model, { price: livePrice });
    }
    var promptText = buildPrompt(model);

    var statusEl = root.querySelector("[data-ai-status]");
    function showStatus() {
      if (!statusEl) return;
      statusEl.hidden = false;
    }

    var logos = root.querySelectorAll(".kya-logo[data-ai]");
    for (var i = 0; i < logos.length; i++) {
      (function (btn) {
        btn.addEventListener("click", function () {
          var ai = btn.getAttribute("data-ai");
          var endpoint = ENDPOINTS[ai];
          if (!endpoint) return;
          copyText(promptText);
          trackClick(ai, key);
          window.open(endpoint + encodeURIComponent(promptText), "_blank", "noopener");
          showStatus();
        });
      })(logos[i]);
    }

    var circles = root.querySelectorAll(".kya-logo-circle img");
    for (var j = 0; j < circles.length; j++) {
      if (circles[j].complete && circles[j].naturalWidth === 0) {
        circles[j].parentNode.classList.add("is-empty");
      }
    }
  }

  function init() {
    var roots = document.querySelectorAll("[data-ai-audit]");
    for (var i = 0; i < roots.length; i++) {
      initAudit(roots[i]);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
